export function isValidDate(date) {
  if (date === null || date === undefined) {
    return true;
  }

  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(date)) {
    return false;
  }

  const parsedDate = new Date(date);
  return parsedDate && !isNaN(parsedDate)
    ? parsedDate.toISOString().startsWith(date)
    : false;
}
